import { useStoreSelector } from 'hooks/store.ts'
import { selectCurrentServiceContracts } from 'store/contact/slice.ts'
import { useGetMeterReadingsQuery } from 'store/queries/bolt-api/contracts'
import { TypedUseQueryHookResult } from '@reduxjs/toolkit/query/react'
import { GetMeterReadingsResponse } from 'store/queries/bolt-api/contracts/types.ts'
import useGetAccessRight from 'hooks/useSelectAccessRight.ts'
import { ACCESS_RIGHT_KEYS } from 'store/access-rights/constants.ts'
import { ENERGY_TYPES } from '@boltenergy-be/shared'
import { hasEnergyTypeValue } from 'store/access-rights/utils.ts'

const useGetCurrentContractMeterReadings = (
  props: {
    customSkip?: boolean
    onlyDgoProvided?: boolean
  } | void
): TypedUseQueryHookResult<GetMeterReadingsResponse['meterReadings'], any, any> => {
  // Redux store
  const { electricity, gas } = useStoreSelector(selectCurrentServiceContracts)

  // Access rights
  const accessRights = useGetAccessRight(ACCESS_RIGHT_KEYS.meterReadings)

  return useGetMeterReadingsQuery(
    {
      electricityContractNumber: accessRights.canAccess.view[ENERGY_TYPES.electricity] ? electricity.contractNumber : undefined,
      gasContractNumber: !!gas && accessRights.canAccess.view[ENERGY_TYPES.gas] ? gas.contractNumber : undefined,
      onlyProvidedByDgo: props?.onlyDgoProvided
    },
    {
      skip: typeof props?.customSkip === 'boolean' ? props.customSkip : !hasEnergyTypeValue(accessRights.canAccess.view)
    }
  )
}

export default useGetCurrentContractMeterReadings
